module.exports = __webpack_public_path__ + "static/img/dragonvr.3c458ef8.png";